import { appData } from '@/mocks/home';

export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl p-6 md:p-10 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-background-100 leading-relaxed mb-6">
              {appData.desc}
            </p>
            <div className="flex flex-wrap gap-3 justify-center lg:justify-start mb-6">
              {appData.features.map((f, i) => (
                <span
                  key={i}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-background-50/20 rounded-full text-background-50 text-xs md:text-sm"
                >
                  <i className="ri-check-line text-sm"></i>
                  {f}
                </span>
              ))}
            </div>
            <div className="flex items-center gap-4 justify-center lg:justify-start">
              <div className="w-28 h-28 md:w-32 md:h-32 bg-background-50 rounded-xl p-2 flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-qr-code-line text-4xl md:text-5xl text-foreground-800"></i>
                  <p className="text-[10px] text-foreground-600 mt-1">微信扫码下载</p>
                </div>
              </div>
              <div className="text-left">
                <p className="text-background-50 text-xs md:text-sm font-medium mb-1">或直接搜索</p>
                <p className="text-background-50 text-base md:text-lg font-bold">"每日大赛"</p>
                <p className="text-background-100 text-xs mt-0.5">App Store / 各大应用商店</p>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 w-48 md:w-56">
            <div className="relative w-full aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={appData.image}
                alt="每日大赛App移动端界面预览"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  const parent = target.parentElement;
                  if (parent) {
                    parent.style.display = 'none';
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}